"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = exports.serializeAws_restJson1ListSipRulesCommand = exports.serializeAws_restJson1ListSipMediaApplicationsCommand = exports.serializeAws_restJson1ListProxySessionsCommand = exports.serializeAws_restJson1ListPhoneNumbersCommand = exports.serializeAws_restJson1ListPhoneNumberOrdersCommand = exports.serializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = exports.serializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = exports.serializeAws_restJson1GetVoiceConnectorTerminationCommand = exports.serializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = exports.serializeAws_restJson1GetVoiceConnectorProxyCommand = exports.serializeAws_restJson1GetVoiceConnectorOriginationCommand = exports.serializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = exports.serializeAws_restJson1GetVoiceConnectorGroupCommand = exports.serializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = exports.serializeAws_restJson1GetVoiceConnectorCommand = exports.serializeAws_restJson1GetSipRuleCommand = exports.serializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = exports.serializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = exports.serializeAws_restJson1GetSipMediaApplicationCommand = exports.serializeAws_restJson1GetProxySessionCommand = exports.serializeAws_restJson1GetPhoneNumberSettingsCommand = exports.serializeAws_restJson1GetPhoneNumberOrderCommand = exports.serializeAws_restJson1GetPhoneNumberCommand = exports.serializeAws_restJson1GetGlobalSettingsCommand = exports.serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = exports.serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = exports.serializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = exports.serializeAws_restJson1DeleteVoiceConnectorTerminationCommand = exports.serializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = exports.serializeAws_restJson1DeleteVoiceConnectorProxyCommand = exports.serializeAws_restJson1DeleteVoiceConnectorOriginationCommand = exports.serializeAws_restJson1DeleteVoiceConnectorGroupCommand = exports.serializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = exports.serializeAws_restJson1DeleteVoiceConnectorCommand = exports.serializeAws_restJson1DeleteSipRuleCommand = exports.serializeAws_restJson1DeleteSipMediaApplicationCommand = exports.serializeAws_restJson1DeleteProxySessionCommand = exports.serializeAws_restJson1DeletePhoneNumberCommand = exports.serializeAws_restJson1CreateVoiceConnectorGroupCommand = exports.serializeAws_restJson1CreateVoiceConnectorCommand = exports.serializeAws_restJson1CreateSipRuleCommand = exports.serializeAws_restJson1CreateSipMediaApplicationCallCommand = exports.serializeAws_restJson1CreateSipMediaApplicationCommand = exports.serializeAws_restJson1CreateProxySessionCommand = exports.serializeAws_restJson1CreatePhoneNumberOrderCommand = exports.serializeAws_restJson1BatchUpdatePhoneNumberCommand = exports.serializeAws_restJson1BatchDeletePhoneNumberCommand = exports.serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = exports.serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = void 0;
exports.deserializeAws_restJson1GetGlobalSettingsCommand = exports.deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = exports.deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorTerminationCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorProxyCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorOriginationCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorGroupCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = exports.deserializeAws_restJson1DeleteVoiceConnectorCommand = exports.deserializeAws_restJson1DeleteSipRuleCommand = exports.deserializeAws_restJson1DeleteSipMediaApplicationCommand = exports.deserializeAws_restJson1DeleteProxySessionCommand = exports.deserializeAws_restJson1DeletePhoneNumberCommand = exports.deserializeAws_restJson1CreateVoiceConnectorGroupCommand = exports.deserializeAws_restJson1CreateVoiceConnectorCommand = exports.deserializeAws_restJson1CreateSipRuleCommand = exports.deserializeAws_restJson1CreateSipMediaApplicationCallCommand = exports.deserializeAws_restJson1CreateSipMediaApplicationCommand = exports.deserializeAws_restJson1CreateProxySessionCommand = exports.deserializeAws_restJson1CreatePhoneNumberOrderCommand = exports.deserializeAws_restJson1BatchUpdatePhoneNumberCommand = exports.deserializeAws_restJson1BatchDeletePhoneNumberCommand = exports.deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = exports.deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = exports.serializeAws_restJson1ValidateE911AddressCommand = exports.serializeAws_restJson1UpdateVoiceConnectorGroupCommand = exports.serializeAws_restJson1UpdateVoiceConnectorCommand = exports.serializeAws_restJson1UpdateSipRuleCommand = exports.serializeAws_restJson1UpdateSipMediaApplicationCallCommand = exports.serializeAws_restJson1UpdateSipMediaApplicationCommand = exports.serializeAws_restJson1UpdateProxySessionCommand = exports.serializeAws_restJson1UpdatePhoneNumberSettingsCommand = exports.serializeAws_restJson1UpdatePhoneNumberCommand = exports.serializeAws_restJson1UpdateGlobalSettingsCommand = exports.serializeAws_restJson1SearchAvailablePhoneNumbersCommand = exports.serializeAws_restJson1RestorePhoneNumberCommand = exports.serializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = exports.serializeAws_restJson1PutVoiceConnectorTerminationCommand = exports.serializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = exports.serializeAws_restJson1PutVoiceConnectorProxyCommand = exports.serializeAws_restJson1PutVoiceConnectorOriginationCommand = exports.serializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = exports.serializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = exports.serializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = exports.serializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = exports.serializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = exports.serializeAws_restJson1ListVoiceConnectorsCommand = exports.serializeAws_restJson1ListVoiceConnectorGroupsCommand = void 0;
exports.deserializeAws_restJson1ValidateE911AddressCommand = exports.deserializeAws_restJson1UpdateVoiceConnectorGroupCommand = exports.deserializeAws_restJson1UpdateVoiceConnectorCommand = exports.deserializeAws_restJson1UpdateSipRuleCommand = exports.deserializeAws_restJson1UpdateSipMediaApplicationCallCommand = exports.deserializeAws_restJson1UpdateSipMediaApplicationCommand = exports.deserializeAws_restJson1UpdateProxySessionCommand = exports.deserializeAws_restJson1UpdatePhoneNumberSettingsCommand = exports.deserializeAws_restJson1UpdatePhoneNumberCommand = exports.deserializeAws_restJson1UpdateGlobalSettingsCommand = exports.deserializeAws_restJson1SearchAvailablePhoneNumbersCommand = exports.deserializeAws_restJson1RestorePhoneNumberCommand = exports.deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = exports.deserializeAws_restJson1PutVoiceConnectorTerminationCommand = exports.deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = exports.deserializeAws_restJson1PutVoiceConnectorProxyCommand = exports.deserializeAws_restJson1PutVoiceConnectorOriginationCommand = exports.deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = exports.deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = exports.deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = exports.deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = exports.deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = exports.deserializeAws_restJson1ListVoiceConnectorsCommand = exports.deserializeAws_restJson1ListVoiceConnectorGroupsCommand = exports.deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = exports.deserializeAws_restJson1ListSipRulesCommand = exports.deserializeAws_restJson1ListSipMediaApplicationsCommand = exports.deserializeAws_restJson1ListProxySessionsCommand = exports.deserializeAws_restJson1ListPhoneNumbersCommand = exports.deserializeAws_restJson1ListPhoneNumberOrdersCommand = exports.deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = exports.deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = exports.deserializeAws_restJson1GetVoiceConnectorTerminationCommand = exports.deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = exports.deserializeAws_restJson1GetVoiceConnectorProxyCommand = exports.deserializeAws_restJson1GetVoiceConnectorOriginationCommand = exports.deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = exports.deserializeAws_restJson1GetVoiceConnectorGroupCommand = exports.deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = exports.deserializeAws_restJson1GetVoiceConnectorCommand = exports.deserializeAws_restJson1GetSipRuleCommand = exports.deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = exports.deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = exports.deserializeAws_restJson1GetSipMediaApplicationCommand = exports.deserializeAws_restJson1GetProxySessionCommand = exports.deserializeAws_restJson1GetPhoneNumberSettingsCommand = exports.deserializeAws_restJson1GetPhoneNumberOrderCommand = exports.deserializeAws_restJson1GetPhoneNumberCommand = void 0;
const protocol_http_1 = require("@aws-sdk/protocol-http");
const smithy_client_1 = require("@aws-sdk/smithy-client");
const ChimeSDKVoiceServiceException_1 = require("../models/ChimeSDKVoiceServiceException");
const models_0_1 = require("../models/models_0");
const serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors/{VoiceConnectorId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    const query = map({
        operation: [, "associate-phone-numbers"],
    });
    let body;
    body = JSON.stringify({
        ...(input.E164PhoneNumbers != null && {
            E164PhoneNumbers: serializeAws_restJson1E164PhoneNumberList(input.E164PhoneNumbers, context),
        }),
        ...(input.ForceAssociate != null && { ForceAssociate: input.ForceAssociate }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand;
const serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connector-groups/{VoiceConnectorGroupId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorGroupId", () => input.VoiceConnectorGroupId, "{VoiceConnectorGroupId}", false);
    const query = map({
        operation: [, "associate-phone-numbers"],
    });
    let body;
    body = JSON.stringify({
        ...(input.E164PhoneNumbers != null && {
            E164PhoneNumbers: serializeAws_restJson1E164PhoneNumberList(input.E164PhoneNumbers, context),
        }),
        ...(input.ForceAssociate != null && { ForceAssociate: input.ForceAssociate }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = serializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand;
const serializeAws_restJson1BatchDeletePhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers";
    const query = map({
        operation: [, "batch-delete"],
    });
    let body;
    body = JSON.stringify({
        ...(input.PhoneNumberIds != null && {
            PhoneNumberIds: serializeAws_restJson1NonEmptyStringList(input.PhoneNumberIds, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1BatchDeletePhoneNumberCommand = serializeAws_restJson1BatchDeletePhoneNumberCommand;
const serializeAws_restJson1BatchUpdatePhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers";
    const query = map({
        operation: [, "batch-update"],
    });
    let body;
    body = JSON.stringify({
        ...(input.UpdatePhoneNumberRequestItems != null && {
            UpdatePhoneNumberRequestItems: serializeAws_restJson1UpdatePhoneNumberRequestItemList(input.UpdatePhoneNumberRequestItems, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1BatchUpdatePhoneNumberCommand = serializeAws_restJson1BatchUpdatePhoneNumberCommand;
const serializeAws_restJson1CreatePhoneNumberOrderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-number-orders";
    let body;
    body = JSON.stringify({
        ...(input.E164PhoneNumbers != null && {
            E164PhoneNumbers: serializeAws_restJson1E164PhoneNumberList(input.E164PhoneNumbers, context),
        }),
        ...(input.ProductType != null && { ProductType: input.ProductType }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreatePhoneNumberOrderCommand = serializeAws_restJson1CreatePhoneNumberOrderCommand;
const serializeAws_restJson1CreateProxySessionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/proxy-sessions";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Capabilities != null && {
            Capabilities: serializeAws_restJson1CapabilityList(input.Capabilities, context),
        }),
        ...(input.ExpiryMinutes != null && { ExpiryMinutes: input.ExpiryMinutes }),
        ...(input.GeoMatchLevel != null && { GeoMatchLevel: input.GeoMatchLevel }),
        ...(input.GeoMatchParams != null && {
            GeoMatchParams: serializeAws_restJson1GeoMatchParams(input.GeoMatchParams, context),
        }),
        ...(input.Name != null && { Name: input.Name }),
        ...(input.NumberSelectionBehavior != null && { NumberSelectionBehavior: input.NumberSelectionBehavior }),
        ...(input.ParticipantPhoneNumbers != null && {
            ParticipantPhoneNumbers: serializeAws_restJson1ParticipantPhoneNumberList(input.ParticipantPhoneNumbers, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateProxySessionCommand = serializeAws_restJson1CreateProxySessionCommand;
const serializeAws_restJson1CreateSipMediaApplicationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-media-applications";
    let body;
    body = JSON.stringify({
        ...(input.AwsRegion != null && { AwsRegion: input.AwsRegion }),
        ...(input.Endpoints != null && {
            Endpoints: serializeAws_restJson1SipMediaApplicationEndpointList(input.Endpoints, context),
        }),
        ...(input.Name != null && { Name: input.Name }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateSipMediaApplicationCommand = serializeAws_restJson1CreateSipMediaApplicationCommand;
const serializeAws_restJson1CreateSipMediaApplicationCallCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/calls";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    body = JSON.stringify({
        ...(input.ArgumentsMap != null && {
            ArgumentsMap: serializeAws_restJson1SMACreateCallArgumentsMap(input.ArgumentsMap, context),
        }),
        ...(input.FromPhoneNumber != null && { FromPhoneNumber: input.FromPhoneNumber }),
        ...(input.SipHeaders != null && { SipHeaders: serializeAws_restJson1SipHeadersMap(input.SipHeaders, context) }),
        ...(input.ToPhoneNumber != null && { ToPhoneNumber: input.ToPhoneNumber }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateSipMediaApplicationCallCommand = serializeAws_restJson1CreateSipMediaApplicationCallCommand;
const serializeAws_restJson1CreateSipRuleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-rules";
    let body;
    body = JSON.stringify({
        ...(input.Disabled != null && { Disabled: input.Disabled }),
        ...(input.Name != null && { Name: input.Name }),
        ...(input.TargetApplications != null && {
            TargetApplications: serializeAws_restJson1SipRuleTargetApplicationList(input.TargetApplications, context),
        }),
        ...(input.TriggerType != null && { TriggerType: input.TriggerType }),
        ...(input.TriggerValue != null && { TriggerValue: input.TriggerValue }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateSipRuleCommand = serializeAws_restJson1CreateSipRuleCommand;
const serializeAws_restJson1CreateVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors";
    let body;
    body = JSON.stringify({
        ...(input.AwsRegion != null && { AwsRegion: input.AwsRegion }),
        ...(input.Name != null && { Name: input.Name }),
        ...(input.RequireEncryption != null && { RequireEncryption: input.RequireEncryption }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateVoiceConnectorCommand = serializeAws_restJson1CreateVoiceConnectorCommand;
const serializeAws_restJson1CreateVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connector-groups";
    let body;
    body = JSON.stringify({
        ...(input.Name != null && { Name: input.Name }),
        ...(input.VoiceConnectorItems != null && {
            VoiceConnectorItems: serializeAws_restJson1VoiceConnectorItemList(input.VoiceConnectorItems, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1CreateVoiceConnectorGroupCommand = serializeAws_restJson1CreateVoiceConnectorGroupCommand;
const serializeAws_restJson1DeletePhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers/{PhoneNumberId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "PhoneNumberId", () => input.PhoneNumberId, "{PhoneNumberId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeletePhoneNumberCommand = serializeAws_restJson1DeletePhoneNumberCommand;
const serializeAws_restJson1DeleteProxySessionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/proxy-sessions/{ProxySessionId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "ProxySessionId", () => input.ProxySessionId, "{ProxySessionId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteProxySessionCommand = serializeAws_restJson1DeleteProxySessionCommand;
const serializeAws_restJson1DeleteSipMediaApplicationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteSipMediaApplicationCommand = serializeAws_restJson1DeleteSipMediaApplicationCommand;
const serializeAws_restJson1DeleteSipRuleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-rules/{SipRuleId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipRuleId", () => input.SipRuleId, "{SipRuleId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteSipRuleCommand = serializeAws_restJson1DeleteSipRuleCommand;
const serializeAws_restJson1DeleteVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors/{VoiceConnectorId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorCommand = serializeAws_restJson1DeleteVoiceConnectorCommand;
const serializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/emergency-calling-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = serializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand;
const serializeAws_restJson1DeleteVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connector-groups/{VoiceConnectorGroupId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorGroupId", () => input.VoiceConnectorGroupId, "{VoiceConnectorGroupId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorGroupCommand = serializeAws_restJson1DeleteVoiceConnectorGroupCommand;
const serializeAws_restJson1DeleteVoiceConnectorOriginationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/origination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorOriginationCommand = serializeAws_restJson1DeleteVoiceConnectorOriginationCommand;
const serializeAws_restJson1DeleteVoiceConnectorProxyCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/programmable-numbers/proxy";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorProxyCommand = serializeAws_restJson1DeleteVoiceConnectorProxyCommand;
const serializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/streaming-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = serializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand;
const serializeAws_restJson1DeleteVoiceConnectorTerminationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "DELETE",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorTerminationCommand = serializeAws_restJson1DeleteVoiceConnectorTerminationCommand;
const serializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination/credentials";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    const query = map({
        operation: [, "delete"],
    });
    let body;
    body = JSON.stringify({
        ...(input.Usernames != null && { Usernames: serializeAws_restJson1SensitiveStringList(input.Usernames, context) }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = serializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand;
const serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors/{VoiceConnectorId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    const query = map({
        operation: [, "disassociate-phone-numbers"],
    });
    let body;
    body = JSON.stringify({
        ...(input.E164PhoneNumbers != null && {
            E164PhoneNumbers: serializeAws_restJson1E164PhoneNumberList(input.E164PhoneNumbers, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand;
const serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connector-groups/{VoiceConnectorGroupId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorGroupId", () => input.VoiceConnectorGroupId, "{VoiceConnectorGroupId}", false);
    const query = map({
        operation: [, "disassociate-phone-numbers"],
    });
    let body;
    body = JSON.stringify({
        ...(input.E164PhoneNumbers != null && {
            E164PhoneNumbers: serializeAws_restJson1E164PhoneNumberList(input.E164PhoneNumbers, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = serializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand;
const serializeAws_restJson1GetGlobalSettingsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/settings";
    let body;
    body = "";
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetGlobalSettingsCommand = serializeAws_restJson1GetGlobalSettingsCommand;
const serializeAws_restJson1GetPhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers/{PhoneNumberId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "PhoneNumberId", () => input.PhoneNumberId, "{PhoneNumberId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetPhoneNumberCommand = serializeAws_restJson1GetPhoneNumberCommand;
const serializeAws_restJson1GetPhoneNumberOrderCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-number-orders/{PhoneNumberOrderId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "PhoneNumberOrderId", () => input.PhoneNumberOrderId, "{PhoneNumberOrderId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetPhoneNumberOrderCommand = serializeAws_restJson1GetPhoneNumberOrderCommand;
const serializeAws_restJson1GetPhoneNumberSettingsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/settings/phone-number";
    let body;
    body = "";
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetPhoneNumberSettingsCommand = serializeAws_restJson1GetPhoneNumberSettingsCommand;
const serializeAws_restJson1GetProxySessionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/proxy-sessions/{ProxySessionId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "ProxySessionId", () => input.ProxySessionId, "{ProxySessionId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetProxySessionCommand = serializeAws_restJson1GetProxySessionCommand;
const serializeAws_restJson1GetSipMediaApplicationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetSipMediaApplicationCommand = serializeAws_restJson1GetSipMediaApplicationCommand;
const serializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/alexa-skill-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = serializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand;
const serializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/logging-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = serializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand;
const serializeAws_restJson1GetSipRuleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-rules/{SipRuleId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipRuleId", () => input.SipRuleId, "{SipRuleId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetSipRuleCommand = serializeAws_restJson1GetSipRuleCommand;
const serializeAws_restJson1GetVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors/{VoiceConnectorId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorCommand = serializeAws_restJson1GetVoiceConnectorCommand;
const serializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/emergency-calling-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = serializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand;
const serializeAws_restJson1GetVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connector-groups/{VoiceConnectorGroupId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorGroupId", () => input.VoiceConnectorGroupId, "{VoiceConnectorGroupId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorGroupCommand = serializeAws_restJson1GetVoiceConnectorGroupCommand;
const serializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/logging-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = serializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand;
const serializeAws_restJson1GetVoiceConnectorOriginationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/origination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorOriginationCommand = serializeAws_restJson1GetVoiceConnectorOriginationCommand;
const serializeAws_restJson1GetVoiceConnectorProxyCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/programmable-numbers/proxy";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorProxyCommand = serializeAws_restJson1GetVoiceConnectorProxyCommand;
const serializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/streaming-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = serializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand;
const serializeAws_restJson1GetVoiceConnectorTerminationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorTerminationCommand = serializeAws_restJson1GetVoiceConnectorTerminationCommand;
const serializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination/health";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = serializeAws_restJson1GetVoiceConnectorTerminationHealthCommand;
const serializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connector-regions";
    let body;
    body = "";
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = serializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand;
const serializeAws_restJson1ListPhoneNumberOrdersCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-number-orders";
    const query = map({
        "next-token": [, input.NextToken],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListPhoneNumberOrdersCommand = serializeAws_restJson1ListPhoneNumberOrdersCommand;
const serializeAws_restJson1ListPhoneNumbersCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers";
    const query = map({
        status: [, input.Status],
        "product-type": [, input.ProductType],
        "filter-name": [, input.FilterName],
        "filter-value": [, input.FilterValue],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
        "next-token": [, input.NextToken],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListPhoneNumbersCommand = serializeAws_restJson1ListPhoneNumbersCommand;
const serializeAws_restJson1ListProxySessionsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/proxy-sessions";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    const query = map({
        status: [, input.Status],
        "next-token": [, input.NextToken],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListProxySessionsCommand = serializeAws_restJson1ListProxySessionsCommand;
const serializeAws_restJson1ListSipMediaApplicationsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-media-applications";
    const query = map({
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
        "next-token": [, input.NextToken],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListSipMediaApplicationsCommand = serializeAws_restJson1ListSipMediaApplicationsCommand;
const serializeAws_restJson1ListSipRulesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-rules";
    const query = map({
        "sip-media-application": [, input.SipMediaApplicationId],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
        "next-token": [, input.NextToken],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListSipRulesCommand = serializeAws_restJson1ListSipRulesCommand;
const serializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-number-countries";
    const query = map({
        "product-type": [, (0, smithy_client_1.expectNonNull)(input.ProductType, `ProductType`)],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = serializeAws_restJson1ListSupportedPhoneNumberCountriesCommand;
const serializeAws_restJson1ListVoiceConnectorGroupsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connector-groups";
    const query = map({
        "next-token": [, input.NextToken],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListVoiceConnectorGroupsCommand = serializeAws_restJson1ListVoiceConnectorGroupsCommand;
const serializeAws_restJson1ListVoiceConnectorsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors";
    const query = map({
        "next-token": [, input.NextToken],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1ListVoiceConnectorsCommand = serializeAws_restJson1ListVoiceConnectorsCommand;
const serializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination/credentials";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = serializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand;
const serializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/alexa-skill-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    body = JSON.stringify({
        ...(input.SipMediaApplicationAlexaSkillConfiguration != null && {
            SipMediaApplicationAlexaSkillConfiguration: serializeAws_restJson1SipMediaApplicationAlexaSkillConfiguration(input.SipMediaApplicationAlexaSkillConfiguration, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = serializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand;
const serializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/logging-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    body = JSON.stringify({
        ...(input.SipMediaApplicationLoggingConfiguration != null && {
            SipMediaApplicationLoggingConfiguration: serializeAws_restJson1SipMediaApplicationLoggingConfiguration(input.SipMediaApplicationLoggingConfiguration, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = serializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand;
const serializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/emergency-calling-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.EmergencyCallingConfiguration != null && {
            EmergencyCallingConfiguration: serializeAws_restJson1EmergencyCallingConfiguration(input.EmergencyCallingConfiguration, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = serializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand;
const serializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/logging-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.LoggingConfiguration != null && {
            LoggingConfiguration: serializeAws_restJson1LoggingConfiguration(input.LoggingConfiguration, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = serializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand;
const serializeAws_restJson1PutVoiceConnectorOriginationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/origination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Origination != null && { Origination: serializeAws_restJson1Origination(input.Origination, context) }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorOriginationCommand = serializeAws_restJson1PutVoiceConnectorOriginationCommand;
const serializeAws_restJson1PutVoiceConnectorProxyCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/programmable-numbers/proxy";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.DefaultSessionExpiryMinutes != null && {
            DefaultSessionExpiryMinutes: input.DefaultSessionExpiryMinutes,
        }),
        ...(input.Disabled != null && { Disabled: input.Disabled }),
        ...(input.FallBackPhoneNumber != null && { FallBackPhoneNumber: input.FallBackPhoneNumber }),
        ...(input.PhoneNumberPoolCountries != null && {
            PhoneNumberPoolCountries: serializeAws_restJson1CountryList(input.PhoneNumberPoolCountries, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorProxyCommand = serializeAws_restJson1PutVoiceConnectorProxyCommand;
const serializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/streaming-configuration";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.StreamingConfiguration != null && {
            StreamingConfiguration: serializeAws_restJson1StreamingConfiguration(input.StreamingConfiguration, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = serializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand;
const serializeAws_restJson1PutVoiceConnectorTerminationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Termination != null && { Termination: serializeAws_restJson1Termination(input.Termination, context) }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorTerminationCommand = serializeAws_restJson1PutVoiceConnectorTerminationCommand;
const serializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/termination/credentials";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    const query = map({
        operation: [, "put"],
    });
    let body;
    body = JSON.stringify({
        ...(input.Credentials != null && { Credentials: serializeAws_restJson1CredentialList(input.Credentials, context) }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = serializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand;
const serializeAws_restJson1RestorePhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers/{PhoneNumberId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "PhoneNumberId", () => input.PhoneNumberId, "{PhoneNumberId}", false);
    const query = map({
        operation: [, "restore"],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1RestorePhoneNumberCommand = serializeAws_restJson1RestorePhoneNumberCommand;
const serializeAws_restJson1SearchAvailablePhoneNumbersCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {};
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/search";
    const query = map({
        type: [, "phone-numbers"],
        "area-code": [, input.AreaCode],
        city: [, input.City],
        country: [, input.Country],
        state: [, input.State],
        "toll-free-prefix": [, input.TollFreePrefix],
        "phone-number-type": [, input.PhoneNumberType],
        "max-results": [() => input.MaxResults !== void 0, () => input.MaxResults.toString()],
        "next-token": [, input.NextToken],
    });
    let body;
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "GET",
        headers,
        path: resolvedPath,
        query,
        body,
    });
};
exports.serializeAws_restJson1SearchAvailablePhoneNumbersCommand = serializeAws_restJson1SearchAvailablePhoneNumbersCommand;
const serializeAws_restJson1UpdateGlobalSettingsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/settings";
    let body;
    body = JSON.stringify({
        ...(input.VoiceConnector != null && {
            VoiceConnector: serializeAws_restJson1VoiceConnectorSettings(input.VoiceConnector, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateGlobalSettingsCommand = serializeAws_restJson1UpdateGlobalSettingsCommand;
const serializeAws_restJson1UpdatePhoneNumberCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/phone-numbers/{PhoneNumberId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "PhoneNumberId", () => input.PhoneNumberId, "{PhoneNumberId}", false);
    let body;
    body = JSON.stringify({
        ...(input.CallingName != null && { CallingName: input.CallingName }),
        ...(input.ProductType != null && { ProductType: input.ProductType }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdatePhoneNumberCommand = serializeAws_restJson1UpdatePhoneNumberCommand;
const serializeAws_restJson1UpdatePhoneNumberSettingsCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/settings/phone-number";
    let body;
    body = JSON.stringify({
        ...(input.CallingName != null && { CallingName: input.CallingName }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdatePhoneNumberSettingsCommand = serializeAws_restJson1UpdatePhoneNumberSettingsCommand;
const serializeAws_restJson1UpdateProxySessionCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connectors/{VoiceConnectorId}/proxy-sessions/{ProxySessionId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "ProxySessionId", () => input.ProxySessionId, "{ProxySessionId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Capabilities != null && {
            Capabilities: serializeAws_restJson1CapabilityList(input.Capabilities, context),
        }),
        ...(input.ExpiryMinutes != null && { ExpiryMinutes: input.ExpiryMinutes }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateProxySessionCommand = serializeAws_restJson1UpdateProxySessionCommand;
const serializeAws_restJson1UpdateSipMediaApplicationCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Endpoints != null && {
            Endpoints: serializeAws_restJson1SipMediaApplicationEndpointList(input.Endpoints, context),
        }),
        ...(input.Name != null && { Name: input.Name }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateSipMediaApplicationCommand = serializeAws_restJson1UpdateSipMediaApplicationCommand;
const serializeAws_restJson1UpdateSipMediaApplicationCallCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/sip-media-applications/{SipMediaApplicationId}/calls/{TransactionId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipMediaApplicationId", () => input.SipMediaApplicationId, "{SipMediaApplicationId}", false);
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "TransactionId", () => input.TransactionId, "{TransactionId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Arguments != null && {
            Arguments: serializeAws_restJson1SMAUpdateCallArgumentsMap(input.Arguments, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateSipMediaApplicationCallCommand = serializeAws_restJson1UpdateSipMediaApplicationCallCommand;
const serializeAws_restJson1UpdateSipRuleCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/sip-rules/{SipRuleId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "SipRuleId", () => input.SipRuleId, "{SipRuleId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Disabled != null && { Disabled: input.Disabled }),
        ...(input.Name != null && { Name: input.Name }),
        ...(input.TargetApplications != null && {
            TargetApplications: serializeAws_restJson1SipRuleTargetApplicationList(input.TargetApplications, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateSipRuleCommand = serializeAws_restJson1UpdateSipRuleCommand;
const serializeAws_restJson1UpdateVoiceConnectorCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/voice-connectors/{VoiceConnectorId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorId", () => input.VoiceConnectorId, "{VoiceConnectorId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Name != null && { Name: input.Name }),
        ...(input.RequireEncryption != null && { RequireEncryption: input.RequireEncryption }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateVoiceConnectorCommand = serializeAws_restJson1UpdateVoiceConnectorCommand;
const serializeAws_restJson1UpdateVoiceConnectorGroupCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    let resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` +
        "/voice-connector-groups/{VoiceConnectorGroupId}";
    resolvedPath = (0, smithy_client_1.resolvedPath)(resolvedPath, input, "VoiceConnectorGroupId", () => input.VoiceConnectorGroupId, "{VoiceConnectorGroupId}", false);
    let body;
    body = JSON.stringify({
        ...(input.Name != null && { Name: input.Name }),
        ...(input.VoiceConnectorItems != null && {
            VoiceConnectorItems: serializeAws_restJson1VoiceConnectorItemList(input.VoiceConnectorItems, context),
        }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "PUT",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1UpdateVoiceConnectorGroupCommand = serializeAws_restJson1UpdateVoiceConnectorGroupCommand;
const serializeAws_restJson1ValidateE911AddressCommand = async (input, context) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const headers = {
        "content-type": "application/json",
    };
    const resolvedPath = `${basePath?.endsWith("/") ? basePath.slice(0, -1) : basePath || ""}` + "/emergency-calling/address";
    let body;
    body = JSON.stringify({
        ...(input.AwsAccountId != null && { AwsAccountId: input.AwsAccountId }),
        ...(input.City != null && { City: input.City }),
        ...(input.Country != null && { Country: input.Country }),
        ...(input.PostalCode != null && { PostalCode: input.PostalCode }),
        ...(input.State != null && { State: input.State }),
        ...(input.StreetInfo != null && { StreetInfo: input.StreetInfo }),
        ...(input.StreetNumber != null && { StreetNumber: input.StreetNumber }),
    });
    return new protocol_http_1.HttpRequest({
        protocol,
        hostname,
        port,
        method: "POST",
        headers,
        path: resolvedPath,
        body,
    });
};
exports.serializeAws_restJson1ValidateE911AddressCommand = serializeAws_restJson1ValidateE911AddressCommand;
const deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand = deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommand;
const deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand = deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommand;
const deserializeAws_restJson1AssociatePhoneNumbersWithVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1BatchDeletePhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchDeletePhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1BatchDeletePhoneNumberCommand = deserializeAws_restJson1BatchDeletePhoneNumberCommand;
const deserializeAws_restJson1BatchDeletePhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1BatchUpdatePhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1BatchUpdatePhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1BatchUpdatePhoneNumberCommand = deserializeAws_restJson1BatchUpdatePhoneNumberCommand;
const deserializeAws_restJson1BatchUpdatePhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreatePhoneNumberOrderCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreatePhoneNumberOrderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberOrder != null) {
        contents.PhoneNumberOrder = deserializeAws_restJson1PhoneNumberOrder(data.PhoneNumberOrder, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreatePhoneNumberOrderCommand = deserializeAws_restJson1CreatePhoneNumberOrderCommand;
const deserializeAws_restJson1CreatePhoneNumberOrderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateProxySessionCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateProxySessionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.ProxySession != null) {
        contents.ProxySession = deserializeAws_restJson1ProxySession(data.ProxySession, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateProxySessionCommand = deserializeAws_restJson1CreateProxySessionCommand;
const deserializeAws_restJson1CreateProxySessionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateSipMediaApplicationCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateSipMediaApplicationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplication != null) {
        contents.SipMediaApplication = deserializeAws_restJson1SipMediaApplication(data.SipMediaApplication, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateSipMediaApplicationCommand = deserializeAws_restJson1CreateSipMediaApplicationCommand;
const deserializeAws_restJson1CreateSipMediaApplicationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateSipMediaApplicationCallCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateSipMediaApplicationCallCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationCall != null) {
        contents.SipMediaApplicationCall = deserializeAws_restJson1SipMediaApplicationCall(data.SipMediaApplicationCall, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateSipMediaApplicationCallCommand = deserializeAws_restJson1CreateSipMediaApplicationCallCommand;
const deserializeAws_restJson1CreateSipMediaApplicationCallCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateSipRuleCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateSipRuleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipRule != null) {
        contents.SipRule = deserializeAws_restJson1SipRule(data.SipRule, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateSipRuleCommand = deserializeAws_restJson1CreateSipRuleCommand;
const deserializeAws_restJson1CreateSipRuleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnector != null) {
        contents.VoiceConnector = deserializeAws_restJson1VoiceConnector(data.VoiceConnector, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateVoiceConnectorCommand = deserializeAws_restJson1CreateVoiceConnectorCommand;
const deserializeAws_restJson1CreateVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1CreateVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1CreateVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnectorGroup != null) {
        contents.VoiceConnectorGroup = deserializeAws_restJson1VoiceConnectorGroup(data.VoiceConnectorGroup, context);
    }
    return contents;
};
exports.deserializeAws_restJson1CreateVoiceConnectorGroupCommand = deserializeAws_restJson1CreateVoiceConnectorGroupCommand;
const deserializeAws_restJson1CreateVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeletePhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeletePhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeletePhoneNumberCommand = deserializeAws_restJson1DeletePhoneNumberCommand;
const deserializeAws_restJson1DeletePhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteProxySessionCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteProxySessionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteProxySessionCommand = deserializeAws_restJson1DeleteProxySessionCommand;
const deserializeAws_restJson1DeleteProxySessionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteSipMediaApplicationCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteSipMediaApplicationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteSipMediaApplicationCommand = deserializeAws_restJson1DeleteSipMediaApplicationCommand;
const deserializeAws_restJson1DeleteSipMediaApplicationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteSipRuleCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteSipRuleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteSipRuleCommand = deserializeAws_restJson1DeleteSipRuleCommand;
const deserializeAws_restJson1DeleteSipRuleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorCommand = deserializeAws_restJson1DeleteVoiceConnectorCommand;
const deserializeAws_restJson1DeleteVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand = deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommand;
const deserializeAws_restJson1DeleteVoiceConnectorEmergencyCallingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorGroupCommand = deserializeAws_restJson1DeleteVoiceConnectorGroupCommand;
const deserializeAws_restJson1DeleteVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorOriginationCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorOriginationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorOriginationCommand = deserializeAws_restJson1DeleteVoiceConnectorOriginationCommand;
const deserializeAws_restJson1DeleteVoiceConnectorOriginationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorProxyCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorProxyCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorProxyCommand = deserializeAws_restJson1DeleteVoiceConnectorProxyCommand;
const deserializeAws_restJson1DeleteVoiceConnectorProxyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand = deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommand;
const deserializeAws_restJson1DeleteVoiceConnectorStreamingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorTerminationCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorTerminationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorTerminationCommand = deserializeAws_restJson1DeleteVoiceConnectorTerminationCommand;
const deserializeAws_restJson1DeleteVoiceConnectorTerminationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand = deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommand;
const deserializeAws_restJson1DeleteVoiceConnectorTerminationCredentialsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand = deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommand;
const deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberErrors != null) {
        contents.PhoneNumberErrors = deserializeAws_restJson1PhoneNumberErrorList(data.PhoneNumberErrors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand = deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommand;
const deserializeAws_restJson1DisassociatePhoneNumbersFromVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetGlobalSettingsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetGlobalSettingsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnector != null) {
        contents.VoiceConnector = deserializeAws_restJson1VoiceConnectorSettings(data.VoiceConnector, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetGlobalSettingsCommand = deserializeAws_restJson1GetGlobalSettingsCommand;
const deserializeAws_restJson1GetGlobalSettingsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetPhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetPhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumber != null) {
        contents.PhoneNumber = deserializeAws_restJson1PhoneNumber(data.PhoneNumber, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetPhoneNumberCommand = deserializeAws_restJson1GetPhoneNumberCommand;
const deserializeAws_restJson1GetPhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetPhoneNumberOrderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetPhoneNumberOrderCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberOrder != null) {
        contents.PhoneNumberOrder = deserializeAws_restJson1PhoneNumberOrder(data.PhoneNumberOrder, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetPhoneNumberOrderCommand = deserializeAws_restJson1GetPhoneNumberOrderCommand;
const deserializeAws_restJson1GetPhoneNumberOrderCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetPhoneNumberSettingsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetPhoneNumberSettingsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.CallingName != null) {
        contents.CallingName = (0, smithy_client_1.expectString)(data.CallingName);
    }
    if (data.CallingNameUpdatedTimestamp != null) {
        contents.CallingNameUpdatedTimestamp = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(data.CallingNameUpdatedTimestamp));
    }
    return contents;
};
exports.deserializeAws_restJson1GetPhoneNumberSettingsCommand = deserializeAws_restJson1GetPhoneNumberSettingsCommand;
const deserializeAws_restJson1GetPhoneNumberSettingsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetProxySessionCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetProxySessionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.ProxySession != null) {
        contents.ProxySession = deserializeAws_restJson1ProxySession(data.ProxySession, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetProxySessionCommand = deserializeAws_restJson1GetProxySessionCommand;
const deserializeAws_restJson1GetProxySessionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetSipMediaApplicationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetSipMediaApplicationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplication != null) {
        contents.SipMediaApplication = deserializeAws_restJson1SipMediaApplication(data.SipMediaApplication, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetSipMediaApplicationCommand = deserializeAws_restJson1GetSipMediaApplicationCommand;
const deserializeAws_restJson1GetSipMediaApplicationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationAlexaSkillConfiguration != null) {
        contents.SipMediaApplicationAlexaSkillConfiguration =
            deserializeAws_restJson1SipMediaApplicationAlexaSkillConfiguration(data.SipMediaApplicationAlexaSkillConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand = deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommand;
const deserializeAws_restJson1GetSipMediaApplicationAlexaSkillConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationLoggingConfiguration != null) {
        contents.SipMediaApplicationLoggingConfiguration = deserializeAws_restJson1SipMediaApplicationLoggingConfiguration(data.SipMediaApplicationLoggingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand = deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommand;
const deserializeAws_restJson1GetSipMediaApplicationLoggingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetSipRuleCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetSipRuleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipRule != null) {
        contents.SipRule = deserializeAws_restJson1SipRule(data.SipRule, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetSipRuleCommand = deserializeAws_restJson1GetSipRuleCommand;
const deserializeAws_restJson1GetSipRuleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnector != null) {
        contents.VoiceConnector = deserializeAws_restJson1VoiceConnector(data.VoiceConnector, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorCommand = deserializeAws_restJson1GetVoiceConnectorCommand;
const deserializeAws_restJson1GetVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.EmergencyCallingConfiguration != null) {
        contents.EmergencyCallingConfiguration = deserializeAws_restJson1EmergencyCallingConfiguration(data.EmergencyCallingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand = deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommand;
const deserializeAws_restJson1GetVoiceConnectorEmergencyCallingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnectorGroup != null) {
        contents.VoiceConnectorGroup = deserializeAws_restJson1VoiceConnectorGroup(data.VoiceConnectorGroup, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorGroupCommand = deserializeAws_restJson1GetVoiceConnectorGroupCommand;
const deserializeAws_restJson1GetVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.LoggingConfiguration != null) {
        contents.LoggingConfiguration = deserializeAws_restJson1LoggingConfiguration(data.LoggingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand = deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommand;
const deserializeAws_restJson1GetVoiceConnectorLoggingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorOriginationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorOriginationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Origination != null) {
        contents.Origination = deserializeAws_restJson1Origination(data.Origination, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorOriginationCommand = deserializeAws_restJson1GetVoiceConnectorOriginationCommand;
const deserializeAws_restJson1GetVoiceConnectorOriginationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorProxyCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorProxyCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Proxy != null) {
        contents.Proxy = deserializeAws_restJson1Proxy(data.Proxy, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorProxyCommand = deserializeAws_restJson1GetVoiceConnectorProxyCommand;
const deserializeAws_restJson1GetVoiceConnectorProxyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.StreamingConfiguration != null) {
        contents.StreamingConfiguration = deserializeAws_restJson1StreamingConfiguration(data.StreamingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand = deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommand;
const deserializeAws_restJson1GetVoiceConnectorStreamingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorTerminationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorTerminationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Termination != null) {
        contents.Termination = deserializeAws_restJson1Termination(data.Termination, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorTerminationCommand = deserializeAws_restJson1GetVoiceConnectorTerminationCommand;
const deserializeAws_restJson1GetVoiceConnectorTerminationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.TerminationHealth != null) {
        contents.TerminationHealth = deserializeAws_restJson1TerminationHealth(data.TerminationHealth, context);
    }
    return contents;
};
exports.deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommand = deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommand;
const deserializeAws_restJson1GetVoiceConnectorTerminationHealthCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnectorRegions != null) {
        contents.VoiceConnectorRegions = deserializeAws_restJson1VoiceConnectorAwsRegionList(data.VoiceConnectorRegions, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand = deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommand;
const deserializeAws_restJson1ListAvailableVoiceConnectorRegionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListPhoneNumberOrdersCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListPhoneNumberOrdersCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.PhoneNumberOrders != null) {
        contents.PhoneNumberOrders = deserializeAws_restJson1PhoneNumberOrderList(data.PhoneNumberOrders, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListPhoneNumberOrdersCommand = deserializeAws_restJson1ListPhoneNumberOrdersCommand;
const deserializeAws_restJson1ListPhoneNumberOrdersCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListPhoneNumbersCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListPhoneNumbersCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.PhoneNumbers != null) {
        contents.PhoneNumbers = deserializeAws_restJson1PhoneNumberList(data.PhoneNumbers, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListPhoneNumbersCommand = deserializeAws_restJson1ListPhoneNumbersCommand;
const deserializeAws_restJson1ListPhoneNumbersCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListProxySessionsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListProxySessionsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.ProxySessions != null) {
        contents.ProxySessions = deserializeAws_restJson1ProxySessions(data.ProxySessions, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListProxySessionsCommand = deserializeAws_restJson1ListProxySessionsCommand;
const deserializeAws_restJson1ListProxySessionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListSipMediaApplicationsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListSipMediaApplicationsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.SipMediaApplications != null) {
        contents.SipMediaApplications = deserializeAws_restJson1SipMediaApplicationList(data.SipMediaApplications, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListSipMediaApplicationsCommand = deserializeAws_restJson1ListSipMediaApplicationsCommand;
const deserializeAws_restJson1ListSipMediaApplicationsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListSipRulesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListSipRulesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.SipRules != null) {
        contents.SipRules = deserializeAws_restJson1SipRuleList(data.SipRules, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListSipRulesCommand = deserializeAws_restJson1ListSipRulesCommand;
const deserializeAws_restJson1ListSipRulesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumberCountries != null) {
        contents.PhoneNumberCountries = deserializeAws_restJson1PhoneNumberCountriesList(data.PhoneNumberCountries, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommand = deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommand;
const deserializeAws_restJson1ListSupportedPhoneNumberCountriesCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListVoiceConnectorGroupsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListVoiceConnectorGroupsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.VoiceConnectorGroups != null) {
        contents.VoiceConnectorGroups = deserializeAws_restJson1VoiceConnectorGroupList(data.VoiceConnectorGroups, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListVoiceConnectorGroupsCommand = deserializeAws_restJson1ListVoiceConnectorGroupsCommand;
const deserializeAws_restJson1ListVoiceConnectorGroupsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListVoiceConnectorsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListVoiceConnectorsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    if (data.VoiceConnectors != null) {
        contents.VoiceConnectors = deserializeAws_restJson1VoiceConnectorList(data.VoiceConnectors, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListVoiceConnectorsCommand = deserializeAws_restJson1ListVoiceConnectorsCommand;
const deserializeAws_restJson1ListVoiceConnectorsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Usernames != null) {
        contents.Usernames = deserializeAws_restJson1SensitiveStringList(data.Usernames, context);
    }
    return contents;
};
exports.deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand = deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommand;
const deserializeAws_restJson1ListVoiceConnectorTerminationCredentialsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationAlexaSkillConfiguration != null) {
        contents.SipMediaApplicationAlexaSkillConfiguration =
            deserializeAws_restJson1SipMediaApplicationAlexaSkillConfiguration(data.SipMediaApplicationAlexaSkillConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand = deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommand;
const deserializeAws_restJson1PutSipMediaApplicationAlexaSkillConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationLoggingConfiguration != null) {
        contents.SipMediaApplicationLoggingConfiguration = deserializeAws_restJson1SipMediaApplicationLoggingConfiguration(data.SipMediaApplicationLoggingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand = deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommand;
const deserializeAws_restJson1PutSipMediaApplicationLoggingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.EmergencyCallingConfiguration != null) {
        contents.EmergencyCallingConfiguration = deserializeAws_restJson1EmergencyCallingConfiguration(data.EmergencyCallingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand = deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommand;
const deserializeAws_restJson1PutVoiceConnectorEmergencyCallingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.LoggingConfiguration != null) {
        contents.LoggingConfiguration = deserializeAws_restJson1LoggingConfiguration(data.LoggingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand = deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommand;
const deserializeAws_restJson1PutVoiceConnectorLoggingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorOriginationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorOriginationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Origination != null) {
        contents.Origination = deserializeAws_restJson1Origination(data.Origination, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorOriginationCommand = deserializeAws_restJson1PutVoiceConnectorOriginationCommand;
const deserializeAws_restJson1PutVoiceConnectorOriginationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorProxyCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorProxyCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Proxy != null) {
        contents.Proxy = deserializeAws_restJson1Proxy(data.Proxy, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorProxyCommand = deserializeAws_restJson1PutVoiceConnectorProxyCommand;
const deserializeAws_restJson1PutVoiceConnectorProxyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.StreamingConfiguration != null) {
        contents.StreamingConfiguration = deserializeAws_restJson1StreamingConfiguration(data.StreamingConfiguration, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand = deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommand;
const deserializeAws_restJson1PutVoiceConnectorStreamingConfigurationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorTerminationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorTerminationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Termination != null) {
        contents.Termination = deserializeAws_restJson1Termination(data.Termination, context);
    }
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorTerminationCommand = deserializeAws_restJson1PutVoiceConnectorTerminationCommand;
const deserializeAws_restJson1PutVoiceConnectorTerminationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand = deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommand;
const deserializeAws_restJson1PutVoiceConnectorTerminationCredentialsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1RestorePhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1RestorePhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumber != null) {
        contents.PhoneNumber = deserializeAws_restJson1PhoneNumber(data.PhoneNumber, context);
    }
    return contents;
};
exports.deserializeAws_restJson1RestorePhoneNumberCommand = deserializeAws_restJson1RestorePhoneNumberCommand;
const deserializeAws_restJson1RestorePhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1SearchAvailablePhoneNumbersCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1SearchAvailablePhoneNumbersCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.E164PhoneNumbers != null) {
        contents.E164PhoneNumbers = deserializeAws_restJson1E164PhoneNumberList(data.E164PhoneNumbers, context);
    }
    if (data.NextToken != null) {
        contents.NextToken = (0, smithy_client_1.expectString)(data.NextToken);
    }
    return contents;
};
exports.deserializeAws_restJson1SearchAvailablePhoneNumbersCommand = deserializeAws_restJson1SearchAvailablePhoneNumbersCommand;
const deserializeAws_restJson1SearchAvailablePhoneNumbersCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "AccessDeniedException":
        case "com.amazonaws.chimesdkvoice#AccessDeniedException":
            throw await deserializeAws_restJson1AccessDeniedExceptionResponse(parsedOutput, context);
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateGlobalSettingsCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateGlobalSettingsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1UpdateGlobalSettingsCommand = deserializeAws_restJson1UpdateGlobalSettingsCommand;
const deserializeAws_restJson1UpdateGlobalSettingsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdatePhoneNumberCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdatePhoneNumberCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.PhoneNumber != null) {
        contents.PhoneNumber = deserializeAws_restJson1PhoneNumber(data.PhoneNumber, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdatePhoneNumberCommand = deserializeAws_restJson1UpdatePhoneNumberCommand;
const deserializeAws_restJson1UpdatePhoneNumberCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdatePhoneNumberSettingsCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdatePhoneNumberSettingsCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
exports.deserializeAws_restJson1UpdatePhoneNumberSettingsCommand = deserializeAws_restJson1UpdatePhoneNumberSettingsCommand;
const deserializeAws_restJson1UpdatePhoneNumberSettingsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateProxySessionCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateProxySessionCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.ProxySession != null) {
        contents.ProxySession = deserializeAws_restJson1ProxySession(data.ProxySession, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateProxySessionCommand = deserializeAws_restJson1UpdateProxySessionCommand;
const deserializeAws_restJson1UpdateProxySessionCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateSipMediaApplicationCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateSipMediaApplicationCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplication != null) {
        contents.SipMediaApplication = deserializeAws_restJson1SipMediaApplication(data.SipMediaApplication, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateSipMediaApplicationCommand = deserializeAws_restJson1UpdateSipMediaApplicationCommand;
const deserializeAws_restJson1UpdateSipMediaApplicationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateSipMediaApplicationCallCommand = async (output, context) => {
    if (output.statusCode !== 202 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateSipMediaApplicationCallCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipMediaApplicationCall != null) {
        contents.SipMediaApplicationCall = deserializeAws_restJson1SipMediaApplicationCall(data.SipMediaApplicationCall, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateSipMediaApplicationCallCommand = deserializeAws_restJson1UpdateSipMediaApplicationCallCommand;
const deserializeAws_restJson1UpdateSipMediaApplicationCallCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateSipRuleCommand = async (output, context) => {
    if (output.statusCode !== 202 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateSipRuleCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.SipRule != null) {
        contents.SipRule = deserializeAws_restJson1SipRule(data.SipRule, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateSipRuleCommand = deserializeAws_restJson1UpdateSipRuleCommand;
const deserializeAws_restJson1UpdateSipRuleCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ResourceLimitExceededException":
        case "com.amazonaws.chimesdkvoice#ResourceLimitExceededException":
            throw await deserializeAws_restJson1ResourceLimitExceededExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateVoiceConnectorCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateVoiceConnectorCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnector != null) {
        contents.VoiceConnector = deserializeAws_restJson1VoiceConnector(data.VoiceConnector, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateVoiceConnectorCommand = deserializeAws_restJson1UpdateVoiceConnectorCommand;
const deserializeAws_restJson1UpdateVoiceConnectorCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1UpdateVoiceConnectorGroupCommand = async (output, context) => {
    if (output.statusCode !== 202 && output.statusCode >= 300) {
        return deserializeAws_restJson1UpdateVoiceConnectorGroupCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.VoiceConnectorGroup != null) {
        contents.VoiceConnectorGroup = deserializeAws_restJson1VoiceConnectorGroup(data.VoiceConnectorGroup, context);
    }
    return contents;
};
exports.deserializeAws_restJson1UpdateVoiceConnectorGroupCommand = deserializeAws_restJson1UpdateVoiceConnectorGroupCommand;
const deserializeAws_restJson1UpdateVoiceConnectorGroupCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ConflictException":
        case "com.amazonaws.chimesdkvoice#ConflictException":
            throw await deserializeAws_restJson1ConflictExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const deserializeAws_restJson1ValidateE911AddressCommand = async (output, context) => {
    if (output.statusCode !== 202 && output.statusCode >= 300) {
        return deserializeAws_restJson1ValidateE911AddressCommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = (0, smithy_client_1.expectNonNull)((0, smithy_client_1.expectObject)(await parseBody(output.body, context)), "body");
    if (data.Address != null) {
        contents.Address = deserializeAws_restJson1Address(data.Address, context);
    }
    if (data.AddressExternalId != null) {
        contents.AddressExternalId = (0, smithy_client_1.expectString)(data.AddressExternalId);
    }
    if (data.CandidateAddressList != null) {
        contents.CandidateAddressList = deserializeAws_restJson1CandidateAddressList(data.CandidateAddressList, context);
    }
    if (data.ValidationResult != null) {
        contents.ValidationResult = (0, smithy_client_1.expectInt32)(data.ValidationResult);
    }
    return contents;
};
exports.deserializeAws_restJson1ValidateE911AddressCommand = deserializeAws_restJson1ValidateE911AddressCommand;
const deserializeAws_restJson1ValidateE911AddressCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.amazonaws.chimesdkvoice#BadRequestException":
            throw await deserializeAws_restJson1BadRequestExceptionResponse(parsedOutput, context);
        case "ForbiddenException":
        case "com.amazonaws.chimesdkvoice#ForbiddenException":
            throw await deserializeAws_restJson1ForbiddenExceptionResponse(parsedOutput, context);
        case "NotFoundException":
        case "com.amazonaws.chimesdkvoice#NotFoundException":
            throw await deserializeAws_restJson1NotFoundExceptionResponse(parsedOutput, context);
        case "ServiceFailureException":
        case "com.amazonaws.chimesdkvoice#ServiceFailureException":
            throw await deserializeAws_restJson1ServiceFailureExceptionResponse(parsedOutput, context);
        case "ServiceUnavailableException":
        case "com.amazonaws.chimesdkvoice#ServiceUnavailableException":
            throw await deserializeAws_restJson1ServiceUnavailableExceptionResponse(parsedOutput, context);
        case "ThrottledClientException":
        case "com.amazonaws.chimesdkvoice#ThrottledClientException":
            throw await deserializeAws_restJson1ThrottledClientExceptionResponse(parsedOutput, context);
        case "UnauthorizedClientException":
        case "com.amazonaws.chimesdkvoice#UnauthorizedClientException":
            throw await deserializeAws_restJson1UnauthorizedClientExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            (0, smithy_client_1.throwDefaultError)({
                output,
                parsedBody,
                exceptionCtor: ChimeSDKVoiceServiceException_1.ChimeSDKVoiceServiceException,
                errorCode,
            });
    }
};
const map = smithy_client_1.map;
const deserializeAws_restJson1AccessDeniedExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.AccessDeniedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1BadRequestExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.BadRequestException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ConflictExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ConflictException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ForbiddenExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ForbiddenException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1NotFoundExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.NotFoundException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ResourceLimitExceededExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ResourceLimitExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ServiceFailureExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ServiceFailureException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ServiceUnavailableExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ServiceUnavailableException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1ThrottledClientExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.ThrottledClientException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const deserializeAws_restJson1UnauthorizedClientExceptionResponse = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    if (data.Code != null) {
        contents.Code = (0, smithy_client_1.expectString)(data.Code);
    }
    if (data.Message != null) {
        contents.Message = (0, smithy_client_1.expectString)(data.Message);
    }
    const exception = new models_0_1.UnauthorizedClientException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents,
    });
    return (0, smithy_client_1.decorateServiceException)(exception, parsedOutput.body);
};
const serializeAws_restJson1AlexaSkillIdList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1CallingRegionList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1CapabilityList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1CountryList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1Credential = (input, context) => {
    return {
        ...(input.Password != null && { Password: input.Password }),
        ...(input.Username != null && { Username: input.Username }),
    };
};
const serializeAws_restJson1CredentialList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1Credential(entry, context);
    });
};
const serializeAws_restJson1DNISEmergencyCallingConfiguration = (input, context) => {
    return {
        ...(input.CallingCountry != null && { CallingCountry: input.CallingCountry }),
        ...(input.EmergencyPhoneNumber != null && { EmergencyPhoneNumber: input.EmergencyPhoneNumber }),
        ...(input.TestPhoneNumber != null && { TestPhoneNumber: input.TestPhoneNumber }),
    };
};
const serializeAws_restJson1DNISEmergencyCallingConfigurationList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1DNISEmergencyCallingConfiguration(entry, context);
    });
};
const serializeAws_restJson1E164PhoneNumberList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1EmergencyCallingConfiguration = (input, context) => {
    return {
        ...(input.DNIS != null && {
            DNIS: serializeAws_restJson1DNISEmergencyCallingConfigurationList(input.DNIS, context),
        }),
    };
};
const serializeAws_restJson1GeoMatchParams = (input, context) => {
    return {
        ...(input.AreaCode != null && { AreaCode: input.AreaCode }),
        ...(input.Country != null && { Country: input.Country }),
    };
};
const serializeAws_restJson1LoggingConfiguration = (input, context) => {
    return {
        ...(input.EnableSIPLogs != null && { EnableSIPLogs: input.EnableSIPLogs }),
    };
};
const serializeAws_restJson1NonEmptyStringList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1Origination = (input, context) => {
    return {
        ...(input.Disabled != null && { Disabled: input.Disabled }),
        ...(input.Routes != null && { Routes: serializeAws_restJson1OriginationRouteList(input.Routes, context) }),
    };
};
const serializeAws_restJson1OriginationRoute = (input, context) => {
    return {
        ...(input.Host != null && { Host: input.Host }),
        ...(input.Port != null && { Port: input.Port }),
        ...(input.Priority != null && { Priority: input.Priority }),
        ...(input.Protocol != null && { Protocol: input.Protocol }),
        ...(input.Weight != null && { Weight: input.Weight }),
    };
};
const serializeAws_restJson1OriginationRouteList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1OriginationRoute(entry, context);
    });
};
const serializeAws_restJson1ParticipantPhoneNumberList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1SensitiveStringList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1SipHeadersMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
const serializeAws_restJson1SipMediaApplicationAlexaSkillConfiguration = (input, context) => {
    return {
        ...(input.AlexaSkillIds != null && {
            AlexaSkillIds: serializeAws_restJson1AlexaSkillIdList(input.AlexaSkillIds, context),
        }),
        ...(input.AlexaSkillStatus != null && { AlexaSkillStatus: input.AlexaSkillStatus }),
    };
};
const serializeAws_restJson1SipMediaApplicationEndpoint = (input, context) => {
    return {
        ...(input.LambdaArn != null && { LambdaArn: input.LambdaArn }),
    };
};
const serializeAws_restJson1SipMediaApplicationEndpointList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1SipMediaApplicationEndpoint(entry, context);
    });
};
const serializeAws_restJson1SipMediaApplicationLoggingConfiguration = (input, context) => {
    return {
        ...(input.EnableSipMediaApplicationMessageLogs != null && {
            EnableSipMediaApplicationMessageLogs: input.EnableSipMediaApplicationMessageLogs,
        }),
    };
};
const serializeAws_restJson1SipRuleTargetApplication = (input, context) => {
    return {
        ...(input.AwsRegion != null && { AwsRegion: input.AwsRegion }),
        ...(input.Priority != null && { Priority: input.Priority }),
        ...(input.SipMediaApplicationId != null && { SipMediaApplicationId: input.SipMediaApplicationId }),
    };
};
const serializeAws_restJson1SipRuleTargetApplicationList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1SipRuleTargetApplication(entry, context);
    });
};
const serializeAws_restJson1SMACreateCallArgumentsMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
const serializeAws_restJson1SMAUpdateCallArgumentsMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
const serializeAws_restJson1StreamingConfiguration = (input, context) => {
    return {
        ...(input.DataRetentionInHours != null && { DataRetentionInHours: input.DataRetentionInHours }),
        ...(input.Disabled != null && { Disabled: input.Disabled }),
        ...(input.StreamingNotificationTargets != null && {
            StreamingNotificationTargets: serializeAws_restJson1StreamingNotificationTargetList(input.StreamingNotificationTargets, context),
        }),
    };
};
const serializeAws_restJson1StreamingNotificationTarget = (input, context) => {
    return {
        ...(input.NotificationTarget != null && { NotificationTarget: input.NotificationTarget }),
    };
};
const serializeAws_restJson1StreamingNotificationTargetList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1StreamingNotificationTarget(entry, context);
    });
};
const serializeAws_restJson1StringList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_restJson1Termination = (input, context) => {
    return {
        ...(input.CallingRegions != null && {
            CallingRegions: serializeAws_restJson1CallingRegionList(input.CallingRegions, context),
        }),
        ...(input.CidrAllowedList != null && {
            CidrAllowedList: serializeAws_restJson1StringList(input.CidrAllowedList, context),
        }),
        ...(input.CpsLimit != null && { CpsLimit: input.CpsLimit }),
        ...(input.DefaultPhoneNumber != null && { DefaultPhoneNumber: input.DefaultPhoneNumber }),
        ...(input.Disabled != null && { Disabled: input.Disabled }),
    };
};
const serializeAws_restJson1UpdatePhoneNumberRequestItem = (input, context) => {
    return {
        ...(input.CallingName != null && { CallingName: input.CallingName }),
        ...(input.PhoneNumberId != null && { PhoneNumberId: input.PhoneNumberId }),
        ...(input.ProductType != null && { ProductType: input.ProductType }),
    };
};
const serializeAws_restJson1UpdatePhoneNumberRequestItemList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1UpdatePhoneNumberRequestItem(entry, context);
    });
};
const serializeAws_restJson1VoiceConnectorItem = (input, context) => {
    return {
        ...(input.Priority != null && { Priority: input.Priority }),
        ...(input.VoiceConnectorId != null && { VoiceConnectorId: input.VoiceConnectorId }),
    };
};
const serializeAws_restJson1VoiceConnectorItemList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_restJson1VoiceConnectorItem(entry, context);
    });
};
const serializeAws_restJson1VoiceConnectorSettings = (input, context) => {
    return {
        ...(input.CdrBucket != null && { CdrBucket: input.CdrBucket }),
    };
};
const deserializeAws_restJson1Address = (output, context) => {
    return {
        city: (0, smithy_client_1.expectString)(output.city),
        country: (0, smithy_client_1.expectString)(output.country),
        postDirectional: (0, smithy_client_1.expectString)(output.postDirectional),
        postalCode: (0, smithy_client_1.expectString)(output.postalCode),
        postalCodePlus4: (0, smithy_client_1.expectString)(output.postalCodePlus4),
        preDirectional: (0, smithy_client_1.expectString)(output.preDirectional),
        state: (0, smithy_client_1.expectString)(output.state),
        streetName: (0, smithy_client_1.expectString)(output.streetName),
        streetNumber: (0, smithy_client_1.expectString)(output.streetNumber),
        streetSuffix: (0, smithy_client_1.expectString)(output.streetSuffix),
    };
};
const deserializeAws_restJson1AlexaSkillIdList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1CallingRegionList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1CandidateAddress = (output, context) => {
    return {
        city: (0, smithy_client_1.expectString)(output.city),
        country: (0, smithy_client_1.expectString)(output.country),
        postalCode: (0, smithy_client_1.expectString)(output.postalCode),
        postalCodePlus4: (0, smithy_client_1.expectString)(output.postalCodePlus4),
        state: (0, smithy_client_1.expectString)(output.state),
        streetInfo: (0, smithy_client_1.expectString)(output.streetInfo),
        streetNumber: (0, smithy_client_1.expectString)(output.streetNumber),
    };
};
const deserializeAws_restJson1CandidateAddressList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1CandidateAddress(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1CapabilityList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1DNISEmergencyCallingConfiguration = (output, context) => {
    return {
        CallingCountry: (0, smithy_client_1.expectString)(output.CallingCountry),
        EmergencyPhoneNumber: (0, smithy_client_1.expectString)(output.EmergencyPhoneNumber),
        TestPhoneNumber: (0, smithy_client_1.expectString)(output.TestPhoneNumber),
    };
};
const deserializeAws_restJson1DNISEmergencyCallingConfigurationList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1DNISEmergencyCallingConfiguration(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1E164PhoneNumberList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1EmergencyCallingConfiguration = (output, context) => {
    return {
        DNIS: output.DNIS != null
            ? deserializeAws_restJson1DNISEmergencyCallingConfigurationList(output.DNIS, context)
            : undefined,
    };
};
const deserializeAws_restJson1GeoMatchParams = (output, context) => {
    return {
        AreaCode: (0, smithy_client_1.expectString)(output.AreaCode),
        Country: (0, smithy_client_1.expectString)(output.Country),
    };
};
const deserializeAws_restJson1LoggingConfiguration = (output, context) => {
    return {
        EnableSIPLogs: (0, smithy_client_1.expectBoolean)(output.EnableSIPLogs),
    };
};
const deserializeAws_restJson1OrderedPhoneNumber = (output, context) => {
    return {
        E164PhoneNumber: (0, smithy_client_1.expectString)(output.E164PhoneNumber),
        Status: (0, smithy_client_1.expectString)(output.Status),
    };
};
const deserializeAws_restJson1OrderedPhoneNumberList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OrderedPhoneNumber(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1Origination = (output, context) => {
    return {
        Disabled: (0, smithy_client_1.expectBoolean)(output.Disabled),
        Routes: output.Routes != null ? deserializeAws_restJson1OriginationRouteList(output.Routes, context) : undefined,
    };
};
const deserializeAws_restJson1OriginationRoute = (output, context) => {
    return {
        Host: (0, smithy_client_1.expectString)(output.Host),
        Port: (0, smithy_client_1.expectInt32)(output.Port),
        Priority: (0, smithy_client_1.expectInt32)(output.Priority),
        Protocol: (0, smithy_client_1.expectString)(output.Protocol),
        Weight: (0, smithy_client_1.expectInt32)(output.Weight),
    };
};
const deserializeAws_restJson1OriginationRouteList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1OriginationRoute(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1Participant = (output, context) => {
    return {
        PhoneNumber: (0, smithy_client_1.expectString)(output.PhoneNumber),
        ProxyPhoneNumber: (0, smithy_client_1.expectString)(output.ProxyPhoneNumber),
    };
};
const deserializeAws_restJson1Participants = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1Participant(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumber = (output, context) => {
    return {
        Associations: output.Associations != null
            ? deserializeAws_restJson1PhoneNumberAssociationList(output.Associations, context)
            : undefined,
        CallingName: (0, smithy_client_1.expectString)(output.CallingName),
        CallingNameStatus: (0, smithy_client_1.expectString)(output.CallingNameStatus),
        Capabilities: output.Capabilities != null
            ? deserializeAws_restJson1PhoneNumberCapabilities(output.Capabilities, context)
            : undefined,
        Country: (0, smithy_client_1.expectString)(output.Country),
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        DeletionTimestamp: output.DeletionTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.DeletionTimestamp)) : undefined,
        E164PhoneNumber: (0, smithy_client_1.expectString)(output.E164PhoneNumber),
        OrderId: (0, smithy_client_1.expectString)(output.OrderId),
        PhoneNumberId: (0, smithy_client_1.expectString)(output.PhoneNumberId),
        ProductType: (0, smithy_client_1.expectString)(output.ProductType),
        Status: (0, smithy_client_1.expectString)(output.Status),
        Type: (0, smithy_client_1.expectString)(output.Type),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
    };
};
const deserializeAws_restJson1PhoneNumberAssociation = (output, context) => {
    return {
        AssociatedTimestamp: output.AssociatedTimestamp != null
            ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.AssociatedTimestamp))
            : undefined,
        Name: (0, smithy_client_1.expectString)(output.Name),
        Value: (0, smithy_client_1.expectString)(output.Value),
    };
};
const deserializeAws_restJson1PhoneNumberAssociationList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PhoneNumberAssociation(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumberCapabilities = (output, context) => {
    return {
        InboundCall: (0, smithy_client_1.expectBoolean)(output.InboundCall),
        InboundMMS: (0, smithy_client_1.expectBoolean)(output.InboundMMS),
        InboundSMS: (0, smithy_client_1.expectBoolean)(output.InboundSMS),
        OutboundCall: (0, smithy_client_1.expectBoolean)(output.OutboundCall),
        OutboundMMS: (0, smithy_client_1.expectBoolean)(output.OutboundMMS),
        OutboundSMS: (0, smithy_client_1.expectBoolean)(output.OutboundSMS),
    };
};
const deserializeAws_restJson1PhoneNumberCountriesList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PhoneNumberCountry(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumberCountry = (output, context) => {
    return {
        CountryCode: (0, smithy_client_1.expectString)(output.CountryCode),
        SupportedPhoneNumberTypes: output.SupportedPhoneNumberTypes != null
            ? deserializeAws_restJson1PhoneNumberTypeList(output.SupportedPhoneNumberTypes, context)
            : undefined,
    };
};
const deserializeAws_restJson1PhoneNumberError = (output, context) => {
    return {
        ErrorCode: (0, smithy_client_1.expectString)(output.ErrorCode),
        ErrorMessage: (0, smithy_client_1.expectString)(output.ErrorMessage),
        PhoneNumberId: (0, smithy_client_1.expectString)(output.PhoneNumberId),
    };
};
const deserializeAws_restJson1PhoneNumberErrorList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PhoneNumberError(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumberList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PhoneNumber(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumberOrder = (output, context) => {
    return {
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        OrderType: (0, smithy_client_1.expectString)(output.OrderType),
        OrderedPhoneNumbers: output.OrderedPhoneNumbers != null
            ? deserializeAws_restJson1OrderedPhoneNumberList(output.OrderedPhoneNumbers, context)
            : undefined,
        PhoneNumberOrderId: (0, smithy_client_1.expectString)(output.PhoneNumberOrderId),
        ProductType: (0, smithy_client_1.expectString)(output.ProductType),
        Status: (0, smithy_client_1.expectString)(output.Status),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
    };
};
const deserializeAws_restJson1PhoneNumberOrderList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1PhoneNumberOrder(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1PhoneNumberTypeList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1Proxy = (output, context) => {
    return {
        DefaultSessionExpiryMinutes: (0, smithy_client_1.expectInt32)(output.DefaultSessionExpiryMinutes),
        Disabled: (0, smithy_client_1.expectBoolean)(output.Disabled),
        FallBackPhoneNumber: (0, smithy_client_1.expectString)(output.FallBackPhoneNumber),
        PhoneNumberCountries: output.PhoneNumberCountries != null
            ? deserializeAws_restJson1StringList(output.PhoneNumberCountries, context)
            : undefined,
    };
};
const deserializeAws_restJson1ProxySession = (output, context) => {
    return {
        Capabilities: output.Capabilities != null ? deserializeAws_restJson1CapabilityList(output.Capabilities, context) : undefined,
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        EndedTimestamp: output.EndedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.EndedTimestamp)) : undefined,
        ExpiryMinutes: (0, smithy_client_1.expectInt32)(output.ExpiryMinutes),
        GeoMatchLevel: (0, smithy_client_1.expectString)(output.GeoMatchLevel),
        GeoMatchParams: output.GeoMatchParams != null
            ? deserializeAws_restJson1GeoMatchParams(output.GeoMatchParams, context)
            : undefined,
        Name: (0, smithy_client_1.expectString)(output.Name),
        NumberSelectionBehavior: (0, smithy_client_1.expectString)(output.NumberSelectionBehavior),
        Participants: output.Participants != null ? deserializeAws_restJson1Participants(output.Participants, context) : undefined,
        ProxySessionId: (0, smithy_client_1.expectString)(output.ProxySessionId),
        Status: (0, smithy_client_1.expectString)(output.Status),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
        VoiceConnectorId: (0, smithy_client_1.expectString)(output.VoiceConnectorId),
    };
};
const deserializeAws_restJson1ProxySessions = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1ProxySession(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1SensitiveStringList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1SipMediaApplication = (output, context) => {
    return {
        AwsRegion: (0, smithy_client_1.expectString)(output.AwsRegion),
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        Endpoints: output.Endpoints != null
            ? deserializeAws_restJson1SipMediaApplicationEndpointList(output.Endpoints, context)
            : undefined,
        Name: (0, smithy_client_1.expectString)(output.Name),
        SipMediaApplicationId: (0, smithy_client_1.expectString)(output.SipMediaApplicationId),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
    };
};
const deserializeAws_restJson1SipMediaApplicationAlexaSkillConfiguration = (output, context) => {
    return {
        AlexaSkillIds: output.AlexaSkillIds != null
            ? deserializeAws_restJson1AlexaSkillIdList(output.AlexaSkillIds, context)
            : undefined,
        AlexaSkillStatus: (0, smithy_client_1.expectString)(output.AlexaSkillStatus),
    };
};
const deserializeAws_restJson1SipMediaApplicationCall = (output, context) => {
    return {
        TransactionId: (0, smithy_client_1.expectString)(output.TransactionId),
    };
};
const deserializeAws_restJson1SipMediaApplicationEndpoint = (output, context) => {
    return {
        LambdaArn: (0, smithy_client_1.expectString)(output.LambdaArn),
    };
};
const deserializeAws_restJson1SipMediaApplicationEndpointList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SipMediaApplicationEndpoint(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1SipMediaApplicationList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SipMediaApplication(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1SipMediaApplicationLoggingConfiguration = (output, context) => {
    return {
        EnableSipMediaApplicationMessageLogs: (0, smithy_client_1.expectBoolean)(output.EnableSipMediaApplicationMessageLogs),
    };
};
const deserializeAws_restJson1SipRule = (output, context) => {
    return {
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        Disabled: (0, smithy_client_1.expectBoolean)(output.Disabled),
        Name: (0, smithy_client_1.expectString)(output.Name),
        SipRuleId: (0, smithy_client_1.expectString)(output.SipRuleId),
        TargetApplications: output.TargetApplications != null
            ? deserializeAws_restJson1SipRuleTargetApplicationList(output.TargetApplications, context)
            : undefined,
        TriggerType: (0, smithy_client_1.expectString)(output.TriggerType),
        TriggerValue: (0, smithy_client_1.expectString)(output.TriggerValue),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
    };
};
const deserializeAws_restJson1SipRuleList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SipRule(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1SipRuleTargetApplication = (output, context) => {
    return {
        AwsRegion: (0, smithy_client_1.expectString)(output.AwsRegion),
        Priority: (0, smithy_client_1.expectInt32)(output.Priority),
        SipMediaApplicationId: (0, smithy_client_1.expectString)(output.SipMediaApplicationId),
    };
};
const deserializeAws_restJson1SipRuleTargetApplicationList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1SipRuleTargetApplication(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1StreamingConfiguration = (output, context) => {
    return {
        DataRetentionInHours: (0, smithy_client_1.expectInt32)(output.DataRetentionInHours),
        Disabled: (0, smithy_client_1.expectBoolean)(output.Disabled),
        StreamingNotificationTargets: output.StreamingNotificationTargets != null
            ? deserializeAws_restJson1StreamingNotificationTargetList(output.StreamingNotificationTargets, context)
            : undefined,
    };
};
const deserializeAws_restJson1StreamingNotificationTarget = (output, context) => {
    return {
        NotificationTarget: (0, smithy_client_1.expectString)(output.NotificationTarget),
    };
};
const deserializeAws_restJson1StreamingNotificationTargetList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1StreamingNotificationTarget(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1StringList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1Termination = (output, context) => {
    return {
        CallingRegions: output.CallingRegions != null
            ? deserializeAws_restJson1CallingRegionList(output.CallingRegions, context)
            : undefined,
        CidrAllowedList: output.CidrAllowedList != null ? deserializeAws_restJson1StringList(output.CidrAllowedList, context) : undefined,
        CpsLimit: (0, smithy_client_1.expectInt32)(output.CpsLimit),
        DefaultPhoneNumber: (0, smithy_client_1.expectString)(output.DefaultPhoneNumber),
        Disabled: (0, smithy_client_1.expectBoolean)(output.Disabled),
    };
};
const deserializeAws_restJson1TerminationHealth = (output, context) => {
    return {
        Source: (0, smithy_client_1.expectString)(output.Source),
        Timestamp: output.Timestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.Timestamp)) : undefined,
    };
};
const deserializeAws_restJson1VoiceConnector = (output, context) => {
    return {
        AwsRegion: (0, smithy_client_1.expectString)(output.AwsRegion),
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        Name: (0, smithy_client_1.expectString)(output.Name),
        OutboundHostName: (0, smithy_client_1.expectString)(output.OutboundHostName),
        RequireEncryption: (0, smithy_client_1.expectBoolean)(output.RequireEncryption),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
        VoiceConnectorArn: (0, smithy_client_1.expectString)(output.VoiceConnectorArn),
        VoiceConnectorId: (0, smithy_client_1.expectString)(output.VoiceConnectorId),
    };
};
const deserializeAws_restJson1VoiceConnectorAwsRegionList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return (0, smithy_client_1.expectString)(entry);
    });
    return retVal;
};
const deserializeAws_restJson1VoiceConnectorGroup = (output, context) => {
    return {
        CreatedTimestamp: output.CreatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.CreatedTimestamp)) : undefined,
        Name: (0, smithy_client_1.expectString)(output.Name),
        UpdatedTimestamp: output.UpdatedTimestamp != null ? (0, smithy_client_1.expectNonNull)((0, smithy_client_1.parseRfc3339DateTime)(output.UpdatedTimestamp)) : undefined,
        VoiceConnectorGroupArn: (0, smithy_client_1.expectString)(output.VoiceConnectorGroupArn),
        VoiceConnectorGroupId: (0, smithy_client_1.expectString)(output.VoiceConnectorGroupId),
        VoiceConnectorItems: output.VoiceConnectorItems != null
            ? deserializeAws_restJson1VoiceConnectorItemList(output.VoiceConnectorItems, context)
            : undefined,
    };
};
const deserializeAws_restJson1VoiceConnectorGroupList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1VoiceConnectorGroup(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1VoiceConnectorItem = (output, context) => {
    return {
        Priority: (0, smithy_client_1.expectInt32)(output.Priority),
        VoiceConnectorId: (0, smithy_client_1.expectString)(output.VoiceConnectorId),
    };
};
const deserializeAws_restJson1VoiceConnectorItemList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1VoiceConnectorItem(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1VoiceConnectorList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_restJson1VoiceConnector(entry, context);
    });
    return retVal;
};
const deserializeAws_restJson1VoiceConnectorSettings = (output, context) => {
    return {
        CdrBucket: (0, smithy_client_1.expectString)(output.CdrBucket),
    };
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBody = (streamBody = new Uint8Array(), context) => {
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then((body) => context.utf8Encoder(body));
const isSerializableHeaderValue = (value) => value !== undefined &&
    value !== null &&
    value !== "" &&
    (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) &&
    (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const parseBody = (streamBody, context) => collectBodyString(streamBody, context).then((encoded) => {
    if (encoded.length) {
        return JSON.parse(encoded);
    }
    return {};
});
const parseErrorBody = async (errorBody, context) => {
    const value = await parseBody(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const loadRestJsonErrorCode = (output, data) => {
    const findKey = (object, key) => Object.keys(object).find((k) => k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue) => {
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") {
            cleanValue = cleanValue.toString();
        }
        if (cleanValue.indexOf(",") >= 0) {
            cleanValue = cleanValue.split(",")[0];
        }
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
};
